import React, { FC, useRef, useState } from "react";
import AppAsyncSelect from '../appAsyncSelect';
import { ISelectProps } from "../SelectProps";
import { SelectValue } from "../SelectValue";
import { ActionService } from '../../../lmsApi/action/service';

const AppActionSelect: FC<ISelectProps> = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const delay = useRef(500);
    const timestamp = useRef(0);

    const loadAction = (inputValue: string, callback: any) => {
        const now = new Date().getTime();
        timestamp.current = now;
        if (!inputValue || inputValue.length < 1) {
            callback(getDefaultOptions());
            return;
        }

        setIsLoading(true);
        setTimeout(async () => {
            if (timestamp.current !== now)
                return;
            try {

                const arItems: SelectValue[] = [];
                const rd = {
                    filter: {
                        name: inputValue
                    }
                };
                const data = await ActionService.list(rd);
                data.items.forEach((item) => {
                    arItems.push({
                        value: `${item.id}` ?? '',
                        label: item.name ?? ''
                    });
                });
                setIsLoading(false);
                callback(arItems);
            }
            catch (err) {
                callback(getDefaultOptions());
            }
        }, delay.current);
    }

    const getDefaultOptions = () => {
        return props.defaultOptions ? props.defaultOptions : [];
    }

    const { options, ...newProps } = props;

    return (
        <AppAsyncSelect {...newProps} options={options} loadOptions={loadAction} loading={isLoading} />
    );
}

export default AppActionSelect;
